import styled from "styled-components";
import Variables from "../../assets/styleVariables";
import { BoxContainer } from "../../assets/globalStyles/styledSettingBox";
import { FIXED_BOTTOM_BAR_BUTTON_HEIGHT } from "../../constants/fixedStyleVariables";

export const Wrapper = styled.div`
  width: 75%;
  padding: 0 32px ${FIXED_BOTTOM_BAR_BUTTON_HEIGHT + 10}px 32px;
  margin: 0 auto;
`;
export const BorderedContainer = styled.div`
  padding: 18px 32px 18px 0;
  border-radius: 4px;
  border: 1px solid ${Variables.colors.complementary_400};
`;
export const InviteMemberContainer = styled.div`
  //width: 40%;
  //-webkit-box-shadow: 0 0 2px 0 #ccc;
  //-moz-box-shadow: 0 0 2px 0 #ccc;
  //box-shadow: 0 0 2px 0 #ccc;
  border: 1px solid ${Variables.colors.complementary_400};
  border-radius: 4px;
  //margin: 0 auto 32px auto;
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-left: 24px;
  padding-bottom: 24px;
  button:first-child {
    margin-left: 8px;
  }
`;

export const BoxContainerRow = styled.div`
  width: 100%;
  min-height: 68px;
  margin-right: 16px;
  padding: 18px 0 18px 32px;
  display: flex;
  justify-content: ${props => (props.justify ? props.justify : "flex-start")};

  &:first-child {
    border-top: 0;
  }

  .edit-link {
    color: ${Variables.colors.tertiary_600};
    cursor: pointer;
  }
  .icon:not(.premium-icon) {
    padding-left: 16px;
    &:before {
      font-size: 16px;
      color: ${Variables.colors.tertiary_600};
    }
  }

  .project-basic-input {
    min-width: 300px;
    color: ${props =>
      props.disabled ? Variables.colors.complementary_600 : "auto"};

    &.reverse {
      direction: ltr;
    }
  }
`;

export const Container = styled.div`
  //margin-top: 48px;
  //padding: 16px 12px;

  .hint {
    font-size: ${Variables.font_sizes.x1_medium};
    color: ${Variables.colors.complementary_700};
    line-height: 1.56;
    margin-bottom: 12px;
  }
  .loading-wrapper {
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Section = styled.div`
  margin-bottom: ${props => (props.mb ? props.mb + "px" : "42px")};
  margin-right: 10px;
  margin-top: 20px;

  .row-half {
    width: 30%;
    display: flex;
    align-items: center;
  }
`;

export const BorderedSection = styled(BorderedContainer)`
  margin-top: 20px;
  .title {
    font-size: ${Variables.font_sizes.x2_medium};
    color: ${Variables.colors.complementary_800};
    font-weight: ${Variables.font_weight.regular};
    margin-bottom: 24px;
  }
  .note {
    font-size: ${Variables.font_sizes.medium};
    color: ${Variables.colors.complementary_600};
    padding: 0 0 16px 16px;
    line-height: 1.5;
    margin-top: -8px;
  }
  .list-container {
    margin-right: 32px;
  }
`;

export const ClickableRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .right-section {
    display: flex;
    align-items: center;
  }
  .arrow-icon {
    padding: 4px 8px;
    margin-right: 16px;
    &:before {
      font-size: 18px;
      color: ${Variables.colors.complementary_700};
    }
  }
`;

export const TitleSection = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  h1 {
    font-size: ${Variables.font_sizes.x2_medium};
    color: ${Variables.colors.complementary_800};
    font-weight: ${Variables.font_weight.regular};
    margin: 0;
    text-align: right;
  }
  .line {
    flex: 1;
    height: 0.8px;
    margin-right: 8px;
    background-color: ${Variables.colors.complementary_450};
  }
`;

const CIRCLE_FIXED_BUTTON_SIZE = 48;
export const CircleFixedButton = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${Variables.colors.complementary_600};
  height: ${CIRCLE_FIXED_BUTTON_SIZE}px;
  width: ${CIRCLE_FIXED_BUTTON_SIZE}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: bottom 0.4s;
  box-shadow: 0 2px 8px 0 #cccccc;
  z-index: 991;
  cursor: pointer;
  i {
    &:before {
      margin-left: 0;
      font-size: 24px;
      color: ${Variables.colors.complementary};
    }
  }
  &:hover {
    background-color: ${Variables.colors.complementary_50};
    i {
      &:before {
        color: ${Variables.colors.complementary_600};
      }
    }
  }
`;

export const RowCardItem = styled.div`
  padding: 18px 0 18px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${Variables.font_sizes.x2_medium};
  color: ${Variables.colors.complementary_800};
  cursor: pointer;

  .right-section {
    .top-text {
      font-size: ${Variables.font_sizes.x1_medium};
      color: ${Variables.colors.complementary_800};
      margin-bottom: 12px;
      display: flex;
    }
    .description {
      font-size: ${Variables.font_sizes.medium};
      color: ${Variables.colors.complementary_700};
      line-height: 1.5;
      text-align: justify;
    }
  }

  border-top: 1px solid ${Variables.colors.complementary_400};
  &:first-child {
    border-top: 0;
  }

  &:hover {
    background-color: ${Variables.colors.complementary_200};
    margin-right: -64px;
    padding-right: 64px;
    & ~ div {
      margin-right: -64px;
      padding-right: 64px;
    }
  }
`;

export const TextInfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .label {
    width: 40%;
    font-size: ${Variables.font_sizes.x_medium};
    font-weight: ${Variables.font_weight.medium};
    color: ${Variables.colors.complementary_700};
  }
  .value {
    margin-left: 8px;
    width: 60%;
    font-size: ${Variables.font_sizes.x1_medium};
    color: ${Variables.colors.complementary_800};
    max-width: 58%;
    display: flex;
    gap: 4px;
    align-items: center;
    &.ellipsis {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .unit {
      margin-right: 4px;
      color: ${Variables.colors.complementary_700};
    }
  }
`;
